import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { MapContainer, TileLayer, Polyline, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix default marker icons when bundling
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow
});

const createEndpointIcon = (label, color) =>
  L.divIcon({
    className: 'rota-endpoint-icon',
    html: `<div style="width:22px;height:22px;border-radius:50%;background:${color};color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;box-shadow:0 0 0 2px #fff">${label}</div>`,
    iconSize: [22, 22],
    iconAnchor: [11, 11]
  });

const parseCaminho = (caminho) => {
  if (!caminho) return [];
  return String(caminho)
    .split(';')
    .map((item) => item.trim())
    .filter(Boolean)
    .map((pair) => {
      const [lat, lng] = pair.split(',').map((v) => Number(String(v).trim()));
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        return { lat, lng };
      }
      return null;
    })
    .filter(Boolean);
};

const buildGoogleDirectionsUrl = (coords) => {
  if (coords.length < 2) return '';
  const origin = coords[0];
  const destination = coords[coords.length - 1];
  return `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&travelmode=driving`;
};

const RotaMapModal = ({ show, onHide, rota, loading = false }) => {
  const caminho = rota?.Caminho ?? rota?.caminho ?? rota?.data?.Caminho ?? rota?.data?.caminho ?? '';
  const coords = parseCaminho(caminho);
  const directionsUrl = buildGoogleDirectionsUrl(coords);
  const bounds = useMemo(() => {
    if (!coords.length) return null;
    const latLngs = coords.map((point) => [point.lat, point.lng]);
    return L.latLngBounds(latLngs);
  }, [coords]);
  const startIcon = useMemo(() => createEndpointIcon('A', '#2563eb'), []);
  const endIcon = useMemo(() => createEndpointIcon('B', '#ef4444'), []);

  const descricao = rota?.Descricao ?? rota?.descricao ?? rota?.data?.Descricao ?? rota?.data?.descricao ?? '';
  const codigo = rota?.CodigoIntegracao ?? rota?.codigoIntegracao ?? rota?.data?.CodigoIntegracao ?? rota?.data?.codigoIntegracao ?? '';
  const distancia = rota?.Distancia ?? rota?.distancia ?? rota?.data?.Distancia ?? rota?.data?.distancia;
  const tempo = rota?.Tempo ?? rota?.tempo ?? rota?.data?.Tempo ?? rota?.data?.tempo;

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Mapa da rota</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: 12 }}>
          {descricao && <div><strong>Rota:</strong> {descricao}</div>}
          {codigo && <div><strong>Codigo:</strong> {codigo}</div>}
          {/* {distancia && <div><strong>Distancia:</strong> {distancia}</div>}
          {tempo && <div><strong>Tempo:</strong> {tempo}</div>} */}
        </div>
        {loading ? (
          <div className="text-muted">Carregando rota...</div>
        ) : coords.length ? (
          <div style={{ border: '1px solid #e5e7eb' }}>
            <div style={{ height: 420 }}>
              <MapContainer
                style={{ height: '100%', width: '100%' }}
                bounds={bounds}
                scrollWheelZoom
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="&copy; OpenStreetMap contributors"
                />
                <Polyline positions={coords.map((point) => [point.lat, point.lng])} />
                <Marker position={[coords[0].lat, coords[0].lng]} icon={startIcon} />
                {coords.length > 1 && (
                  <Marker position={[coords[coords.length - 1].lat, coords[coords.length - 1].lng]} icon={endIcon} />
                )}
              </MapContainer>
            </div>
            {directionsUrl && (
              <div style={{ padding: '8px 12px', borderTop: '1px solid #e5e7eb' }}>
                <a href={directionsUrl} target="_blank" rel="noreferrer">
                  Abrir rota no Google Maps
                </a>
              </div>
            )}
          </div>
        ) : (
          <div className="text-muted">Sem caminho disponivel para exibir no mapa.</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default RotaMapModal;
